<template>
  <div class="dialogCon" >
    <el-dialog
        width="624px"
        title="个人中心"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        center=""
        @close="submitTap('ruleForm')">
      <el-form  :model="form" :rules="rules" ref="ruleForm" label-width="100px"  >
        <el-form-item label="手机号码:"  :label-width="formLabelWidth"  >
          <el-input v-model="form.mobile"  autocomplete="off" disabled ></el-input>
          <div style=" color:rgb(187, 187, 187);height: 28px;line-height: 30px; " >
            手机号码为了登录账户，不可更改。
          </div>
        </el-form-item>

        <el-form-item label="姓名:" prop="real_name" :label-width="formLabelWidth">
          <el-input v-model="form.real_name" placeholder="请输入员工昵称" autocomplete="off" ></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="sex" :label-width="formLabelWidth">
          <el-radio-group v-model="form.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="医师注册号:" prop="doctor_registration_number" :label-width="formLabelWidth">
          <el-input v-model="form.doctor_registration_number" placeholder="请输入医师注册号" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="avatar_url" :label-width="formLabelWidth">
          <uploadImg  @uploads="uploadData" :limit="1" :data="photoData" v-model="form.avatar_url"  ></uploadImg>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitTap('ruleForm')">取 消</el-button>
        <el-button type="FF7" @click="submitForm('ruleForm')" :loading="loading" >保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
	import {appendImg} from "../../common/js/util";
    import uploadImg from '@/components/common/uploads/uploadImg.vue'
	export default {
		components:{
			uploadImg,
		},
		name:'addEmployee',
		props:['status'],
		data() {
			return {
				photoData:[], //照片墙初始化
				formLabelWidth:"110px",
				loading:false,
				dialogFormVisible:false,
				form:{
					mobile:"",
					real_name:"",
					sex:"",
					avatar_url:"",
					doctor_registration_number:""
				},
				rules: {
					real_name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					sex: [
						{ required: true, message: '请选择性别', trigger: 'blur' }
					],
						avatar_url: [
						{ required: true, message: '请输上传头像', trigger: 'blur' }
					],
				},
			};
		},
		watch:{
			status(val){
				 this.dialogFormVisible = val
			}
		},
		mounted(){
			 this.getInfo();
		},
		methods:{
			//获取信息
			getInfo(){
			   this.$ajax({
					'method': 'com.get.merchant_user.info.data',
					'x_account_type':'merchant_user',
				}).then(res => {
					if (res.status == 10000) {
						this.form = res.data;
						if(res.data.avatar_url){
							this.photoData=[{
								file_path : res.data.avatar_url
							}];
						}	
					} else {
						this.messages(res.info, 'warning');
					}
				});	
			},
			// 取消
			submitTap(formName){
				this.getInfo();
				this.$emit('add',false)
				this.$refs[formName].resetFields();
			},
			uploadData(data){
				this.form.avatar_url=data[0].file_path
			},
			//保存
			submitForm(formName) {
 				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loading = true;
						this.$ajax({
							method: 'com.set.merchant_user.info.save',
							x_account_type:'merchant_user',
							data:this.form
						}).then(res => {
							if (res.status == 10000) {
								this.loading = false;
								this.messages(res.info, 'success');
								let user = JSON.parse(localStorage.getItem('tokenInfo'));
								user.merchant_user_name = this.form.real_name;
								user.merchant_user_avatar = appendImg(this.photoData[0].file_path);
								localStorage.setItem('tokenInfo',JSON.stringify(user));
								localStorage.setItem('updateToken',"12");
								this.getInfo();
								this.$emit('add',false)
							} else {
								this.loading = false;
								this.messages(res.info, 'warning');
							}
						});
					} 
 				});
			}
		}
	}

</script>

<style scoped lang="scss">
// @import '~scss_vars';
.dialogCon .el-input{width: 440px;}
// .dialogCon .el-dialog__wrapper .el-dialog{width:634px !important;}
// .editItem{margin-left: 30px;width:400px;height:40px;line-height: 40px;}
// .labell{display: inline-block;width:90px;text-align: right;}q
// .imgPhoto{width:100px;margin-top:10px;}
// .imgCon{display: inline-block;width:101px;height:101px;border:1px solid #FFFFFF;}
// .showCon .el-dialog .el-dialog__body{height: 320px !important;}
</style>



// WEBPACK FOOTER //
// personCenter.vue?ddc5e2ea